import { render } from "./LanguageAvailability.vue?vue&type=template&id=e7002986"
import script from "./LanguageAvailability.vue?vue&type=script&lang=js"
export * from "./LanguageAvailability.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__